var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_718",
    "data-name": "Group 718",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.297,
    height: 77.296,
    viewBox: "0 0 77.297 77.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 77.297,
    height: 77.296,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M77.3,38.649A38.648,38.648,0,1,1,38.648,0,38.65,38.65,0,0,1,77.3,38.649",
    transform: "translate(0.002 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M41.609,28.187a1.347,1.347,0,0,0-1.219-.779L13.53,27.3a1.349,1.349,0,0,0-1.224.771L4.1,45.325a1.351,1.351,0,0,0,1.214,1.93l43.126.17a1.35,1.35,0,0,0,1.232-1.92Zm.686,7.869-8.42-.033-1.327-5.946,6.975.028Zm-19.546-.078,1.375-5.934,5.653.023L31.1,36.011Zm8.958,2.737,1.329,5.949-12.288-.05,1.375-5.936ZM14.379,30.007l6.973.028-1.375,5.934-8.417-.033Zm-4.1,8.625,9.076.035L17.979,44.6,7.456,44.561Zm25.528,6.041-1.327-5.946,9.076.035,2.774,5.954ZM50.988,28.8a10.871,10.871,0,0,1-1.89,6.094,1.351,1.351,0,0,1-2.233-1.522,8.209,8.209,0,0,0-6.755-12.826,8.244,8.244,0,0,0-7.143,4.1,1.352,1.352,0,0,1-2.338-1.357A10.914,10.914,0,0,1,50.988,28.8m-12.2-15.28L38.8,8.8a1.351,1.351,0,1,1,2.7.01l-.02,4.719a1.351,1.351,0,0,1-2.7-.01M25.067,15.543a1.35,1.35,0,0,1,1.918-1.9l3.322,3.347a1.351,1.351,0,1,1-1.918,1.9Zm36.309,13.3a1.353,1.353,0,0,1-1.357,1.347l-4.717-.02a1.351,1.351,0,0,1,.01-2.7l4.719.02a1.348,1.348,0,0,1,1.344,1.354M55.189,15.664l-3.35,3.322a1.351,1.351,0,0,1-1.9-1.918l3.35-3.322a1.351,1.351,0,0,1,1.9,1.918",
    transform: "translate(5.974 11.207)",
    fill: "#eaff50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sun_icon.0daf743007272b25c9563002ef4b44eb.svg";
export { ForwardRef as ReactComponent };